import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import 'rc-tooltip/assets/bootstrap_white.css';
import {
    fetchOdsDetailsRequest,
    fetchAvailableBalanceRequest,
    fetchProcessOdsRequest,
    fetchNetSettlementRequest,
} from 'containers/Settlement/redux/settlement.actions';
import Tooltip from 'rc-tooltip';
import removeIcon from '../../static/images/remove.png';
import tickIcon from '../../static/images/tick.png';
import { Popup, FormElems } from '..';
import infoIcon from '../../static/images/orangeinfo.png';

const OdsCard = ({ auth, actions, settlementData, fetchData }) => {
    const availableBalance = settlementData.availableBalance?.availableBalance;
    const netSettlementAmount = settlementData.netSettlementAmount.totalSettlementAmount || 0;
    const availableBalanceError = settlementData.availableBalanceError;
    const availableBalanceLoading = settlementData.availableBalanceLoading;
    const [isOpen, setIsOpen] = React.useState(false);
    const [isSuccess, setIsSuccess] = React.useState(false);

    const handleOpen = () => {
        const handleSuccess = () => {
            setIsOpen(true);
        };

        actions.fetchOdsDetailsRequest(
            {
                entityId: auth.userDetails.associatedEntityId,
            },
            handleSuccess
        );
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleSettlement = () => {
        const handleProcessODSSuccess = () => {
            setIsSuccess(true);
            setIsOpen(false);
            fetchData({ pageSize: 10, pageIndex: 1 });
        };

        actions.fetchProcessOdsRequest(
            {
                entityId: auth.userDetails.associatedEntityId,
            },
            handleProcessODSSuccess
        );
    };

    const handleSuccessClose = () => {
        actions.fetchAvailableBalanceRequest({
            entityId: auth.userDetails.associatedEntityId,
        });
        setIsSuccess(false);
    };

    const handleRefresh = () => {
        actions.fetchAvailableBalanceRequest({
            entityId: auth.userDetails.associatedEntityId,
        });
        actions.fetchNetSettlementRequest({
            entityId: auth.userDetails.associatedEntityId,
        });
    };

    return (
        <div className="card custom-ods-card">
            {/* eslint-disable-next-line react/no-unescaped-entities */}
            <h2 className="tab-title">Today's Summary</h2>
            <div className={'data-section'}>
                <div className={'data-section-left'}>
                    <div className="data-section-inner">
                        <h5>Gross Amount</h5>
                        <p> ₹ {Number(availableBalance).toFixed(2)}</p>
                    </div>
                    <div className="data-section-inner">
                        <h5>Net Settlement</h5>
                        <p> ₹ {Number(netSettlementAmount).toFixed(2)}</p>
                    </div>
                </div>
                <div className={'footer'}>
                    <FormElems.Button
                        id="refresh-btn"
                        buttonType="secondary"
                        text="Refresh"
                        type="button"
                        customClass="back-btn"
                        handleClick={handleRefresh}
                    />
                    <FormElems.Button
                        id="settlement-btn"
                        buttonType="primary"
                        text={'Settle Now'}
                        handleClick={handleOpen}
                        isDisable={
                            !availableBalance ||
                            availableBalance <= (settlementData?.odsFeeDetails?.odsConfigInfo?.minOdsAmount || 0) ||
                            availableBalanceLoading ||
                            availableBalanceError
                        }
                    />
                </div>
            </div>

            <Popup title="Instant Settlement" showCloseIcon showOverlay closePopup={handleClose} showFilter={isOpen}>
                <div className="settlement-container">
                    <div className="settlement-card">
                        <h2>Settlement Detail</h2>
                        <div className="detail-row">
                            <span>
                                <span>Payable Amount</span>
                                <span className="small-text">After Deducting transaction fees</span>
                            </span>
                            <span>₹{settlementData?.odsFeeDetails?.availableBalance}</span>
                        </div>
                        <div className="detail-row">
                            <span>Settlement Fees</span>
                            <span>₹{settlementData?.odsFeeDetails?.odsFee}</span>
                        </div>
                        <div className="detail-row">
                            <span>
                                GST{' '}
                                <span className="small-text">
                                    ({settlementData?.odsFeeDetails?.odsConfigInfo?.odSfeeInfo.tax}% of Fees)
                                </span>
                            </span>
                            <span>₹{settlementData?.odsFeeDetails?.tax}</span>
                        </div>
                        <div className="detail-row total">
                            <span className={'total-text'}>
                                Amount to be Settled
                                <Tooltip
                                    placement="left"
                                    overlay={
                                        <div className={`custom-tooltip`}>
                                            The final settlement amount may vary as successful transactions are
                                            processed during settlement
                                        </div>
                                    }
                                    styles={{
                                        root: { zIndex: 9999 },
                                        body: { zIndex: 99999999, opacity: 1 },
                                    }}
                                >
                                    <img src={infoIcon} alt={`info`} />
                                </Tooltip>
                            </span>
                            <span>₹{settlementData?.odsFeeDetails?.amountTobeSettled}</span>
                        </div>
                    </div>
                    <div className="bank-details-ods">
                        <h2>Bank Details</h2>
                        <div className="detail-row">
                            <span>Account Number</span>
                            <span>{settlementData?.odsFeeDetails?.accountNumber}</span>
                        </div>
                        <div className="detail-row">
                            <span>IFSC Code</span>
                            <span>{settlementData?.odsFeeDetails?.ifscCode}</span>
                        </div>
                    </div>
                    <p className="note">Amount would be credited to your bank account within 15 mins</p>
                    <div className={'popup-footer'}>
                        <FormElems.Button
                            id="back-btn"
                            buttonType="secondary"
                            text="Cancel"
                            type="button"
                            customClass="back-btn"
                            handleClick={handleClose}
                        />
                        <FormElems.Button
                            id="next-btn"
                            buttonType="primary"
                            text="Settle Now"
                            handleClick={handleSettlement}
                        />
                    </div>
                </div>
            </Popup>
            <SettlementSuccessModal
                isOpen={isSuccess}
                handleSuccessClose={handleSuccessClose}
                settlementData={settlementData}
            />
        </div>
    );
};

const SettlementSuccessModal = ({ isOpen, handleSuccessClose, settlementData }) =>
    isOpen ? (
        <div className={'modal-overlay settlement-success-modal'}>
            <div className={'modal-content'}>
                <div className={'modal-header-ods'}>
                    <div className={'modal-close-icon'} onClick={handleSuccessClose}>
                        <img src={removeIcon} alt={'close icon'} />
                    </div>
                </div>
                <div className={'icon-container'}>
                    <img src={tickIcon} alt="tick icon" />
                </div>
                <h2>Congratulations</h2>
                <p className={'settlement-description'}>Your settlement amount has been settled successfully</p>
                <div className="settlement-detail">
                    <div className="details">
                        <h4>Account Number</h4>
                        <p>{settlementData?.settledAmount?.accountNumber}</p>
                    </div>
                    <div className="details">
                        <h4>Settlement Amount</h4>
                        <p>₹{settlementData?.settledAmount?.settledAmount}</p>
                    </div>
                </div>
            </div>
        </div>
    ) : null;

SettlementSuccessModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    handleSuccessClose: PropTypes.func.isRequired,
    settlementData: PropTypes.object,
};

OdsCard.propTypes = {
    auth: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    settlementData: PropTypes.object,
    fetchData: PropTypes.func,
};

const mapStateToProps = ({ auth, loader }) => ({
    auth,
    loader,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchOdsDetailsRequest,
            fetchAvailableBalanceRequest,
            fetchProcessOdsRequest,
            fetchNetSettlementRequest,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(OdsCard);
